export const elementIds = {
  POLICYBREAKDOWN:'POLICYBREAKDOWN',
  AMLMATCHES:'AMLMATCHES',
}